import CloseIcon from "@mui/icons-material/Close";

import { createColor } from "./createColor";
import styles from "./Tag.module.css";

export interface TagProps {
  label: string;
  /**
   * Optional leading-dot color (any CSS color string).
   */
  color?: string;
  /**
   * Optional onClick callback. When set, the tag body (dot + label) renders as
   * a real button so it is keyboard- and screen-reader-accessible.
   */
  onClick?: () => void;
  /**
   * Optional onDelete callback. If set, renders a delete button.
   */
  onDelete?: () => void;
}

export function Tag(props: TagProps) {
  const { label, onClick, onDelete, color = createColor(props.label) } = props;

  const content = (
    <>
      <span className={styles.dot} style={{ backgroundColor: color }} />
      {label}
    </>
  );

  return (
    <span className={styles.tag}>
      {onClick ? (
        // A real <button> (not a span with role="button") gives focus, Enter
        // and Space activation for free. It wraps only the body — the delete
        // button stays a sibling, so no interactive elements are nested.
        <button type="button" className={styles.body} onClick={onClick}>
          {content}
        </button>
      ) : (
        content
      )}
      {onDelete && (
        <button
          className={styles.deleteButton}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          aria-label={`Remove ${label}`}
          type="button"
        >
          <CloseIcon style={{ fontSize: "0.625rem" }} />
        </button>
      )}
    </span>
  );
}
